import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type PostRequestExportRequest = {
  startAt: Date;
  endAt: Date;
  wasteStreamIds?: number[];
  suburbs?: string[];
  streets?: string[];
  requestTypes: string[];
  includeComplete?: boolean;
  includeInProgress?: boolean;
  includePending?: boolean;
  referenceNumber?: string;
};

export const postRequestExport = async (request: PostRequestExportRequest) => {
  const response = await executeApiRequest<Blob>(
    () => axios.post<Blob>("/requests/export", request, { responseType: "blob", withCredentials: true }),
    false
  );

  const blobData = new Blob([response.data]);
  const url = window.URL.createObjectURL(blobData);
  const link = document.createElement("a");
  link.href = url;

  // Try to extract filename from Content-Disposition header (case-insensitive)
  let filename = "export.xlsx";
  const disposition = response.headers && (response.headers["content-disposition"] || response.headers["Content-Disposition"]);
  if (disposition) {
    const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
    if (match) {
      filename = decodeURIComponent(match[1] || match[2]);
    }
  }
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(url);

  return response.data;
};
